// export const homePath = "/";
// export const error404 = "*";
// export const companyPath = "/edit";
// export const companyEdit = `${companyPath}/:id`;

import OrderOverview from "pages/Account/OrderOverview";


// export const test = {
//     path = "/";

// }
const companyPath = 'firma';
const myAccountPath = 'konto';
const webshopPath = 'nettbutikk';

export const UrlPath = {
  Frontpage : {
      Home: "/"
  },
  ProductDescriptions: `/produktbeskrivelse`,
    Account: {
    Company : `/${companyPath}`,
    CompanyEdit: `/${companyPath}/:id`,
    LogDetails: `/${companyPath}/:id/logg/:changeLogId`,
    CompanyEditElements: `/${companyPath}/:id/:element`,
    Statistics: `/${companyPath}/:id/statistikk/`,
    Products: `/${companyPath}/:id/produkter/`,
    ProductConfigBase: `/${companyPath}/:id/produkter/:product`,
    ProductConfig: {
      Logo: "logo",
      ExtraLinks: "ekstra-lenker",
      BulletPoints: "punktliste",
      InfoText: "beskrivelse",
      SearchWords: "sokeord"
    },
    OrderOverview: `/${companyPath}/:id/ordre/`,
    InfoSite: `/${companyPath}/:id/infoside/`,
    WebshopOld: `/${companyPath}/:id/nettbutikk/`,
    Actions: {
        Details: "detaljer",
        PhoneNumbers: "kontakter",
        Products: "produkter",
        Invoices: "faktura",
        Logg: "logg",
        AccessManagement: "endringstilgang",
        Links: "lenker",
        Industries: "bransjer",
        Statistics: "statistikk",
        OpeningHours: "apningstider",
        InfoSite: "infoside",
        Webshop: "butikk",
        WebshopOld: "nettbutikk",
        Ordre: "ordre"
    },
  WebShopBase: `/${webshopPath}`,
  WebShop: `/${webshopPath}/:id`,
  WebShopProducts: `/${webshopPath}/:id/:product`,
  WebShopActions: {
    Checkout: `checkout`
  },
  ShoppingCartBase: `/handlekurv`,
  ShoppingCart: `/handlekurv/:id`},
  MyAccount: {
    Home: `/${myAccountPath}`,
    AddCompany: `/${myAccountPath}/leggtilbedrift`
  }
}